import Colors from '../theme/Colors'

export type TextSize = 12 | 14 | 16 | 18 | 24 | 36 | 44

export default function Text(props: {
  children: React.ReactNode
  display?: React.CSSProperties['display']
  color?: keyof typeof Colors
  size?: TextSize
  bold?: boolean // Note that both semi-bold and bold share the same weight
  italic?: boolean
  underline?: boolean
  lineThrough?: boolean
}) {
  const { children, display, color, size, bold, italic, underline, lineThrough, ...rest } = props
  const style: React.CSSProperties = {
    display,
    color: color ? Colors[color] : undefined,
    fontSize: size ? size + 'px' : undefined,
    fontWeight: getStyle(bold, 600, 400),
    textDecoration: getTextDecorator(underline, lineThrough),
    fontStyle: getStyle(italic, 'italic', 'normal'),
  }
  return (
    <span {...rest} style={style}>
      {props.children}
    </span>
  )
}

function getStyle<T>(value: boolean | undefined, trueCase: T, falseCase: T): T | undefined {
  if (value === undefined) {
    return undefined
  }

  return value ? trueCase : falseCase
}

function getTextDecorator(underline?: boolean, lineThrough?: boolean) {
  if (underline && lineThrough) {
    return getStyle(underline && lineThrough, 'underline line-through', 'none')
  }

  if (underline !== undefined && !lineThrough) {
    return getStyle(underline, 'underline', 'none')
  }

  if (!underline && lineThrough !== undefined) {
    return getStyle(lineThrough, 'line-through', 'none')
  }

  return undefined
}
